export const state = () => ({ continuationToken: null })

export const mutations = {
  setContinuationToken(state, value) {
    state.continuationToken = value
  }
}

export const actions = {
  async getData({ dispatch, commit, state }, { applianceId }) {
    const continuationToken = state.continuationToken
    const data = await this.$apiAaltra.applianceLogs(
      applianceId,
      continuationToken
    )

    await commit('setContinuationToken', data.continuation)

    return data
  }
}
